{
  // multi selects are hard to use for standard users because it requires you to hold shift or option while clicking which people may not understand
  // this makes it so much easier by allowing clicks to toggle selected or not
  document.addEventListener('mousedown', e => {
    if(e.target.tagName === 'OPTION' && e.target.closest('select[multiple]')){
      e.preventDefault()
      e.target.selected = !e.target.selected
      // trigger change event
      const event = new Event('change', { bubbles: true })
      e.target.closest('select[multiple]').dispatchEvent(event)
    }
  })
}